// Auto-generated gallery catalog data
export const CATALOG_PHOTOS = [
  {
    id: 'iwd26-group-0',
    src: '/assets/gallery/iwd26/iwd26-group-01.jpeg',
    title: 'IWD Innovation Summit 2026 — Group Photo',
    category: 'IWD Summit 2026',
    folder: 'iwd26',
    photographer: 'Heart of the City Photography x Shawn Lee Studios',
    photographerUrl: 'https://www.hocxsls.com/',
    featured: true,
  },
  {
    id: 'iwd26-group-1',
    src: '/assets/gallery/iwd26/iwd26-group-02.jpeg',
    title: 'IWD Innovation Summit 2026 — Group Photo',
    category: 'IWD Summit 2026',
    folder: 'iwd26',
    photographer: 'Heart of the City Photography x Shawn Lee Studios',
    photographerUrl: 'https://www.hocxsls.com/',
    featured: true,
  },
  {
    id: 'iwd26-group-2',
    src: '/assets/gallery/iwd26/iwd26-group-03.jpeg',
    title: 'IWD Innovation Summit 2026 — Group Photo',
    category: 'IWD Summit 2026',
    folder: 'iwd26',
    photographer: 'Heart of the City Photography x Shawn Lee Studios',
    photographerUrl: 'https://www.hocxsls.com/',
    featured: true,
  },
  {
    id: 'iwd26-group-4',
    src: '/assets/gallery/iwd26/iwd26-group-04.jpeg',
    title: 'IWD Innovation Summit 2026 — Group Photo',
    category: 'IWD Summit 2026',
    folder: 'iwd26',
    photographer: 'Heart of the City Photography x Shawn Lee Studios',
    photographerUrl: 'https://www.hocxsls.com/',
    featured: true,
  },
  {
    id: 'iwd26-group-5',
    src: '/assets/gallery/iwd26/iwd26-group-05.jpeg',
    title: 'IWD Innovation Summit 2026 — Group Photo',
    category: 'IWD Summit 2026',
    folder: 'iwd26',
    photographer: 'Heart of the City Photography x Shawn Lee Studios',
    photographerUrl: 'https://www.hocxsls.com/',
    featured: true,
  },
  {
    id: 'img-7',
    src: '/assets/gallery/devfest25/Student pictures/022e16f6-4555-4285-847d-f98332ebcf8d.jpg',
    title: 'DevFest 2025 - Moment 7',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-8',
    src: '/assets/gallery/devfest25/Student pictures/11421de5-2098-462e-8dc6-d2251b2493ac.jpg',
    title: 'DevFest 2025 - Moment 8',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-9',
    src: '/assets/gallery/devfest25/Student pictures/92ece131-d2f8-4ff3-bb03-0eb7c6062f3a.jpg',
    title: 'DevFest 2025 - Moment 9',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-10',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0532.jpg',
    title: 'DevFest 2025 - Moment 10',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-11',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0533.jpg',
    title: 'DevFest 2025 - Moment 11',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-12',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0534.jpg',
    title: 'DevFest 2025 - Moment 12',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-13',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0535.jpg',
    title: 'DevFest 2025 - Moment 13',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-14',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0539.jpg',
    title: 'DevFest 2025 - Moment 14',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-15',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0540.jpg',
    title: 'DevFest 2025 - Moment 15',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-16',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0543.jpg',
    title: 'DevFest 2025 - Moment 16',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-17',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0544.jpg',
    title: 'DevFest 2025 - Moment 17',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-18',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0545.jpg',
    title: 'DevFest 2025 - Moment 18',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-19',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0546.jpg',
    title: 'DevFest 2025 - Moment 19',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-20',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0547.jpg',
    title: 'DevFest 2025 - Moment 20',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-21',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0548.jpg',
    title: 'DevFest 2025 - Moment 21',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-22',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0553.jpg',
    title: 'DevFest 2025 - Moment 22',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-23',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0554.jpg',
    title: 'DevFest 2025 - Moment 23',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-24',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0555.jpg',
    title: 'DevFest 2025 - Moment 24',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-25',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0556.jpg',
    title: 'DevFest 2025 - Moment 25',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-26',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0557.jpg',
    title: 'DevFest 2025 - Moment 26',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-27',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0558.jpg',
    title: 'DevFest 2025 - Moment 27',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-28',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0559.jpg',
    title: 'DevFest 2025 - Moment 28',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-29',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0560.jpg',
    title: 'DevFest 2025 - Moment 29',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-30',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0575.jpg',
    title: 'DevFest 2025 - Moment 30',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-31',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0576.jpg',
    title: 'DevFest 2025 - Moment 31',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-32',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0577.jpg',
    title: 'DevFest 2025 - Moment 32',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-33',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0578.jpg',
    title: 'DevFest 2025 - Moment 33',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-34',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0579.jpg',
    title: 'DevFest 2025 - Moment 34',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-35',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0580.jpg',
    title: 'DevFest 2025 - Moment 35',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-36',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0581.jpg',
    title: 'DevFest 2025 - Moment 36',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-37',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0582.jpg',
    title: 'DevFest 2025 - Moment 37',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-38',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0584.jpg',
    title: 'DevFest 2025 - Moment 38',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-39',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0585.jpg',
    title: 'DevFest 2025 - Moment 39',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-40',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0587.jpg',
    title: 'DevFest 2025 - Moment 40',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-41',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0588.jpg',
    title: 'DevFest 2025 - Moment 41',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-42',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0590.jpg',
    title: 'DevFest 2025 - Moment 42',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-43',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0591.jpg',
    title: 'DevFest 2025 - Moment 43',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-44',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0592.jpg',
    title: 'DevFest 2025 - Moment 44',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-45',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0593.jpg',
    title: 'DevFest 2025 - Moment 45',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-46',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0594.jpg',
    title: 'DevFest 2025 - Moment 46',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-47',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0595.jpg',
    title: 'DevFest 2025 - Moment 47',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-48',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0596.jpg',
    title: 'DevFest 2025 - Moment 48',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-49',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0597.jpg',
    title: 'DevFest 2025 - Moment 49',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-50',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0598.jpg',
    title: 'DevFest 2025 - Moment 50',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-51',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0599.jpg',
    title: 'DevFest 2025 - Moment 51',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-52',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0600.jpg',
    title: 'DevFest 2025 - Moment 52',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-53',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0601.jpg',
    title: 'DevFest 2025 - Moment 53',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-54',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0602.jpg',
    title: 'DevFest 2025 - Moment 54',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-55',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0603.jpg',
    title: 'DevFest 2025 - Moment 55',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-56',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0604.jpg',
    title: 'DevFest 2025 - Moment 56',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-57',
    src: '/assets/gallery/devfest25/Student pictures/IMG_0605.jpg',
    title: 'DevFest 2025 - Moment 57',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-58',
    src: '/assets/gallery/devfest25/Student pictures/IMG_6570.JPG',
    title: 'DevFest 2025 - Moment 58',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-59',
    src: '/assets/gallery/devfest25/Student pictures/IMG_6571.JPG',
    title: 'DevFest 2025 - Moment 59',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-60',
    src: '/assets/gallery/devfest25/Student pictures/IMG_6572.JPG',
    title: 'DevFest 2025 - Moment 60',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-61',
    src: '/assets/gallery/devfest25/Student pictures/IMG_6573.JPG',
    title: 'DevFest 2025 - Moment 61',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-62',
    src: '/assets/gallery/devfest25/Student pictures/IMG_6574.JPG',
    title: 'DevFest 2025 - Moment 62',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-63',
    src: '/assets/gallery/devfest25/Student pictures/d473a47b-69d2-48ff-aa63-1bb01f7b9aaf.jpg',
    title: 'DevFest 2025 - Moment 63',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-64',
    src: '/assets/gallery/devfest25/Student pictures/dadc3fd6-cfaa-454b-994e-8c439cda346b.JPG',
    title: 'DevFest 2025 - Moment 64',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-65',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0520.jpg',
    title: 'DevFest 2025 - Moment 65',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-66',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0521.jpg',
    title: 'DevFest 2025 - Moment 66',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-67',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0522.jpg',
    title: 'DevFest 2025 - Moment 67',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-68',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0523.jpg',
    title: 'DevFest 2025 - Moment 68',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-69',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0524.jpg',
    title: 'DevFest 2025 - Moment 69',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-70',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0526.jpg',
    title: 'DevFest 2025 - Moment 70',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-71',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0527.jpg',
    title: 'DevFest 2025 - Moment 71',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-72',
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0529.jpg',
    title: 'DevFest 2025 - Moment 72',
    category: 'DevFest 2025',
    folder: 'devfest25',
  },
  {
    id: 'img-73',
    src: '/assets/gallery/iwd25/IMG_1113.PNG',
    title: 'IWD Summit 2025 - Moment 73',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-74',
    src: '/assets/gallery/iwd25/IMG_1115.PNG',
    title: 'IWD Summit 2025 - Moment 74',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-75',
    src: '/assets/gallery/iwd25/IMG_1366.jpg',
    title: 'IWD Summit 2025 - Moment 75',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-76',
    src: '/assets/gallery/iwd25/IMG_1367.jpg',
    title: 'IWD Summit 2025 - Moment 76',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-77',
    src: '/assets/gallery/iwd25/IMG_1404.jpg',
    title: 'IWD Summit 2025 - Moment 77',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-78',
    src: '/assets/gallery/iwd25/IMG_1413.jpg',
    title: 'IWD Summit 2025 - Moment 78',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-79',
    src: '/assets/gallery/iwd25/IMG_1422.jpg',
    title: 'IWD Summit 2025 - Moment 79',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-80',
    src: '/assets/gallery/iwd25/IMG_1424.jpg',
    title: 'IWD Summit 2025 - Moment 80',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-81',
    src: '/assets/gallery/iwd25/IMG_1437.jpg',
    title: 'IWD Summit 2025 - Moment 81',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-82',
    src: '/assets/gallery/iwd25/IMG_1444.jpg',
    title: 'IWD Summit 2025 - Moment 82',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-83',
    src: '/assets/gallery/iwd25/IMG_1448.jpg',
    title: 'IWD Summit 2025 - Moment 83',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-84',
    src: '/assets/gallery/iwd25/IMG_1455.jpg',
    title: 'IWD Summit 2025 - Moment 84',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-85',
    src: '/assets/gallery/iwd25/IMG_1461.jpg',
    title: 'IWD Summit 2025 - Moment 85',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-86',
    src: '/assets/gallery/iwd25/IMG_1678 2.jpg',
    title: 'IWD Summit 2025 - Moment 86',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-87',
    src: '/assets/gallery/iwd25/IMG_5099.jpeg',
    title: 'IWD Summit 2025 - Moment 87',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-88',
    src: '/assets/gallery/iwd25/IMG_5100.jpeg',
    title: 'IWD Summit 2025 - Moment 88',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-89',
    src: '/assets/gallery/iwd25/IMG_5101.jpeg',
    title: 'IWD Summit 2025 - Moment 89',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-90',
    src: '/assets/gallery/iwd25/IMG_5102.jpeg',
    title: 'IWD Summit 2025 - Moment 90',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-91',
    src: '/assets/gallery/iwd25/IMG_5103.jpeg',
    title: 'IWD Summit 2025 - Moment 91',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-92',
    src: '/assets/gallery/iwd25/IMG_5105.jpeg',
    title: 'IWD Summit 2025 - Moment 92',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-93',
    src: '/assets/gallery/iwd25/IMG_5106.jpeg',
    title: 'IWD Summit 2025 - Moment 93',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-94',
    src: '/assets/gallery/iwd25/IMG_5107.jpeg',
    title: 'IWD Summit 2025 - Moment 94',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-95',
    src: '/assets/gallery/iwd25/IMG_5108.jpeg',
    title: 'IWD Summit 2025 - Moment 95',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-96',
    src: '/assets/gallery/iwd25/IMG_5109.jpeg',
    title: 'IWD Summit 2025 - Moment 96',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-97',
    src: '/assets/gallery/iwd25/IMG_5110.jpeg',
    title: 'IWD Summit 2025 - Moment 97',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-98',
    src: '/assets/gallery/iwd25/IMG_5111.jpeg',
    title: 'IWD Summit 2025 - Moment 98',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-99',
    src: '/assets/gallery/iwd25/IMG_5112.jpeg',
    title: 'IWD Summit 2025 - Moment 99',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-100',
    src: '/assets/gallery/iwd25/IMG_5113.jpeg',
    title: 'IWD Summit 2025 - Moment 100',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-101',
    src: '/assets/gallery/iwd25/IMG_5114.jpeg',
    title: 'IWD Summit 2025 - Moment 101',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-102',
    src: '/assets/gallery/iwd25/IMG_5115.jpeg',
    title: 'IWD Summit 2025 - Moment 102',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-103',
    src: '/assets/gallery/iwd25/IMG_5116.jpeg',
    title: 'IWD Summit 2025 - Moment 103',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-104',
    src: '/assets/gallery/iwd25/IMG_5117.jpeg',
    title: 'IWD Summit 2025 - Moment 104',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-105',
    src: '/assets/gallery/iwd25/IMG_5118.jpeg',
    title: 'IWD Summit 2025 - Moment 105',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-106',
    src: '/assets/gallery/iwd25/IMG_5119.jpeg',
    title: 'IWD Summit 2025 - Moment 106',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-107',
    src: '/assets/gallery/iwd25/IMG_5120.jpeg',
    title: 'IWD Summit 2025 - Moment 107',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-108',
    src: '/assets/gallery/iwd25/IMG_5121.jpeg',
    title: 'IWD Summit 2025 - Moment 108',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-109',
    src: '/assets/gallery/iwd25/IMG_5122.jpeg',
    title: 'IWD Summit 2025 - Moment 109',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-110',
    src: '/assets/gallery/iwd25/IMG_5123.jpeg',
    title: 'IWD Summit 2025 - Moment 110',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-111',
    src: '/assets/gallery/iwd25/IMG_5124.jpeg',
    title: 'IWD Summit 2025 - Moment 111',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-112',
    src: '/assets/gallery/iwd25/IMG_5126.jpeg',
    title: 'IWD Summit 2025 - Moment 112',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-113',
    src: '/assets/gallery/iwd25/IMG_5127.jpeg',
    title: 'IWD Summit 2025 - Moment 113',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-114',
    src: '/assets/gallery/iwd25/IMG_5128.jpeg',
    title: 'IWD Summit 2025 - Moment 114',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-115',
    src: '/assets/gallery/iwd25/IMG_5129.jpeg',
    title: 'IWD Summit 2025 - Moment 115',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-116',
    src: '/assets/gallery/iwd25/IMG_5130.jpeg',
    title: 'IWD Summit 2025 - Moment 116',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-117',
    src: '/assets/gallery/iwd25/IMG_5131.jpeg',
    title: 'IWD Summit 2025 - Moment 117',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-118',
    src: '/assets/gallery/iwd25/IMG_5132.jpeg',
    title: 'IWD Summit 2025 - Moment 118',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-119',
    src: '/assets/gallery/iwd25/IMG_5133.jpeg',
    title: 'IWD Summit 2025 - Moment 119',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-120',
    src: '/assets/gallery/iwd25/IMG_5134.jpeg',
    title: 'IWD Summit 2025 - Moment 120',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-121',
    src: '/assets/gallery/iwd25/IMG_5135.jpeg',
    title: 'IWD Summit 2025 - Moment 121',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-122',
    src: '/assets/gallery/iwd25/IMG_5136.jpeg',
    title: 'IWD Summit 2025 - Moment 122',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-123',
    src: '/assets/gallery/iwd25/IMG_5137.jpeg',
    title: 'IWD Summit 2025 - Moment 123',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-124',
    src: '/assets/gallery/iwd25/IMG_5138.jpeg',
    title: 'IWD Summit 2025 - Moment 124',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-125',
    src: '/assets/gallery/iwd25/IMG_5139.jpeg',
    title: 'IWD Summit 2025 - Moment 125',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-126',
    src: '/assets/gallery/iwd25/IMG_5140.jpeg',
    title: 'IWD Summit 2025 - Moment 126',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-127',
    src: '/assets/gallery/iwd25/IMG_5141.jpeg',
    title: 'IWD Summit 2025 - Moment 127',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-128',
    src: '/assets/gallery/iwd25/IMG_5142.jpeg',
    title: 'IWD Summit 2025 - Moment 128',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-129',
    src: '/assets/gallery/iwd25/IMG_5144.jpeg',
    title: 'IWD Summit 2025 - Moment 129',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
  {
    id: 'img-130',
    src: '/assets/gallery/iwd25/IMG_5145.jpeg',
    title: 'IWD Summit 2025 - Moment 130',
    category: 'IWD Summit 2025',
    folder: 'iwd25',
  },
]
